import { render, staticRenderFns } from "./Scene8.vue?vue&type=template&id=7b789eb3&"
import script from "./Scene8.vue?vue&type=script&lang=js&"
export * from "./Scene8.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports